// extracted by mini-css-extract-plugin
export var education = "Education-module--education--R9k3+";
export var title = "Education-module--title--z4PSp";
export var education__wrap = "Education-module--education__wrap--Q1UrZ";
export var education__cards = "Education-module--education__cards--uzNJ0";
export var education__cards__one_card = "Education-module--education__cards__one_card--hOrho";
export var education__cards__one_card__img = "Education-module--education__cards__one_card__img--daohT";
export var education__cards__one_card__texts = "Education-module--education__cards__one_card__texts--9-k1C";
export var education__cards__one_card__texts__title = "Education-module--education__cards__one_card__texts__title--XMf8i";
export var education__cards__one_card__texts__text = "Education-module--education__cards__one_card__texts__text--4fHk+";